import { Card } from '@/components/ui/card';
import { Eye, Edit2, Trash2 } from 'lucide-react';
import { getStatusColor, formatDateRange } from './constants';
import RecentActivityPill from './RecentActivityPill';

export function CompetitionCard({ competition, venues, activity, onView, onEdit, onDelete }) {
  const getVenueName = (venueId) => {
    const venue = venues.find(v => v.venue_id === venueId);
    return venue ? venue.venue_name : 'No venue assigned';
  };
  
  return (
    <Card className="p-5" data-testid={`competition-card-${competition.competition_id}`}>
      {/* Header with title and status */}
      <div className="flex items-start justify-between mb-2">
        <h3 className="text-lg font-semibold text-[#2D4A3E]">{competition.name}</h3>
        <span className={`text-xs font-medium px-2 py-1 rounded ${getStatusColor(competition.status)}`}>
          {competition.status || 'Draft'}
        </span>
      </div>
      
      {/* Venue */}
      <p className="text-sm text-muted-foreground mb-1">
        {getVenueName(competition.venue_id)}
      </p>
      
      {/* Date Range */}
      <p className="text-sm text-muted-foreground mb-3">
        {formatDateRange(competition.start_date, competition.end_date)}
      </p>

      {/* Recent Activity Pill (Feb 2026) */}
      <RecentActivityPill activity={activity} competitionId={competition.competition_id} />

      {/* Horizontal Rule */}
      <hr className="border-stone-200 my-3" />
      
      {/* Created By - now using creator_name from API */}
      <p className="text-xs text-muted-foreground mb-3">
        Created by {competition.creator_name || 'Unknown'}
      </p>
      
      {/* Bottom row: View/Edit links and badges */}
      <div className="flex items-center justify-between">
        {/* Action Links */}
        <div className="flex items-center gap-3">
          <button 
            onClick={() => onView(competition)}
            className="flex items-center gap-1 text-sm text-[#4A7C59] hover:underline"
            data-testid={`view-competition-${competition.competition_id}`}
          >
            <Eye className="h-3.5 w-3.5" />
            View
          </button>
          <button 
            onClick={() => onEdit(competition)}
            className="flex items-center gap-1 text-sm text-[#4A7C59] hover:underline"
            data-testid={`edit-competition-${competition.competition_id}`}
          >
            <Edit2 className="h-3.5 w-3.5" />
            Edit
          </button>
          <button 
            onClick={() => onDelete(competition.competition_id)}
            className="flex items-center gap-1 text-sm text-[#4A7C59] hover:underline"
            data-testid={`delete-competition-${competition.competition_id}`}
          >
            <Trash2 className="h-3.5 w-3.5" />
            Delete
          </button>
        </div>
        
        {/* Event Type Badges */}
        <div className="flex gap-2">
          {competition.artistic_events_included && (
            <span className="text-xs font-medium px-2 py-1 rounded bg-[#4A7C59] text-white">
              Artistic
            </span>
          )}
          {competition.figure_events_included && (
            <span className="text-xs font-medium px-2 py-1 rounded bg-[#8B7355] text-white">
              Figures
            </span>
          )}
        </div>
      </div>
    </Card>
  );
}
